import React, { useEffect, useState } from "react"
import { InputAdornment } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import { couriersForMethod } from "../../../helpers/courier";

const EditShippedOrder = (props) => {
    const [shippingMethod, setShippingMethod] = useState();
    const [courierService, setCourierService] = useState();
    const [trackingNum, setTrackingNum] = useState();
    const [trackingUrl, setTrackingUrl] = useState();

    useEffect(() => {
        if (props?.orderData) {
            setShippingMethod(props?.orderData?.shipping_method_id || '');
            setCourierService(props?.orderData?.courier_service || '');
            setTrackingNum(props?.orderData?.tracking_number || '');
            setTrackingUrl(props?.orderData?.tracking_url || '');
        }
    }, [props?.orderData])

    const handleSubmit = () => {
        let payload = {
            shipping_method_id: shippingMethod,
            courier_service: courierService,
            tracking_no: trackingNum,
            tracking_url: trackingUrl,
        }
        props.submit(payload);
    }

    const selectedMethod = (props?.shippingMethodList || []).find((item) => String(item.id) === String(shippingMethod));
    const courierOptions = couriersForMethod(selectedMethod, courierService);

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Edit shipping details'}
            titleIcon={'edit'}
            positiveTitle={'Save changes'}
            positivePress={() => handleSubmit()}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'40%'}
        >
            <div className="">
                <div className="mb-3">
                    Please enters the tracking details and confirm to set the order status to “Shipped”.
                </div>
                <CustomSelect
                    title={'Shipping method'}
                    values={shippingMethod || '-1'}
                    placeholder={'Please select'}
                    data={props?.shippingMethodList || []}
                    valueName={'id'}
                    labelName={'title'}
                    onChange={(value) => {
                        setShippingMethod(value);
                        const nextMethod = (props?.shippingMethodList || []).find((item) => String(item.id) === String(value));
                        const nextCouriers = couriersForMethod(nextMethod, courierService);
                        if (!nextCouriers.some((row) => row.value === courierService || row.label === courierService)) {
                            setCourierService('');
                        }
                    }}
                />
                <div className="my-3">
                    <CustomSelect
                        title={'Courier service'}
                        values={courierService || '-1'}
                        placeholder={'Please select'}
                        data={courierOptions}
                        onChange={setCourierService}
                    />
                </div>
                <div className="my-3">
                    <CustomTextField
                        title={'Tracking Number'}
                        values={trackingNum}
                        onChange={setTrackingNum}
                    />
                </div>
                <CustomTextField
                    title={'Tracking URL'}
                    values={trackingUrl}
                    onChange={setTrackingUrl}
                />
            </div>
        </AppDialog>
    )
}

export default EditShippedOrder;